var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1683",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11047",
    d: "M.5-1.75a.5.5 0 0 1-.5.5.5.5 0 0 1-.5-.5v-2.5a.5.5 0 0 1 .5-.5.5.5 0 0 1 .5.5zM0-14a4 4 0 0 1 4 4v2h.5A2.5 2.5 0 0 1 7-5.5v5A2.5 2.5 0 0 1 4.5 2h-9A2.5 2.5 0 0 1-7-.5v-5A2.5 2.5 0 0 1-4.5-8h.5v-2a4 4 0 0 1 4-4zm0 1a2.983 2.983 0 0 0-3 3v2h6v-2a3 3 0 0 0-3-3zm-4.5 6A1.5 1.5 0 0 0-6-5.5v5A1.5 1.5 0 0 0-4.5 1h9A1.5 1.5 0 0 0 6-.5v-5A1.5 1.5 0 0 0 4.5-7z",
    transform: "translate(10 16)",
    style: {
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: ".1px"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.d7c41a09cd6fecc159ab8db0d2ee299a.svg";
export { ForwardRef as ReactComponent };